var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHistory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1218_940)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 5.33333C28.2799 5.33333 28.2266 5.36 28.1733 5.37333C28.1066 5.36 28.0533 5.33333 27.9999 5.33333H26.6666V1.33333C26.6666 0.6 26.0666 0 25.3333 0H5.33325C3.35992 0 1.71992 1.44 1.39992 3.33333C1.35992 3.44 1.33325 3.54667 1.33325 3.66667V28.3333C1.33325 30.36 2.97325 32 4.99992 32H28.3333C28.8799 32 29.3333 31.5467 29.3333 31V6.33333C29.3333 5.78667 28.8799 5.33333 28.3333 5.33333ZM15.3333 27.3333C10.5599 27.3333 6.66659 23.44 6.66659 18.6667C6.66659 13.8933 10.5599 10 15.3333 10C20.1066 10 23.9999 13.8933 23.9999 18.6667C23.9999 23.44 20.1066 27.3333 15.3333 27.3333ZM23.9999 5.33333H5.33325C4.59992 5.33333 3.99992 4.73333 3.99992 4C3.99992 3.26667 4.59992 2.66667 5.33325 2.66667H23.9999V5.33333Z",
    fill: "#F2EED5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 21.9999C16.992 21.9999 16.6507 21.8692 16.3907 21.6092L14.3907 19.6092C14.14 19.3599 14 19.0212 14 18.6666V14.6666C14 13.9293 14.5973 13.3333 15.3333 13.3333C16.0693 13.3333 16.6667 13.9293 16.6667 14.6666V18.1146L18.276 19.7239C18.7973 20.2452 18.7973 21.0879 18.276 21.6092C18.016 21.8692 17.6747 21.9999 17.3333 21.9999Z",
    fill: "#F2EED5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1218_940"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.004445e83b8b1d157fe24ee65d667ab2.svg";
export { ForwardRef as ReactComponent };